import React from "react";
import "./Hero.scss";
import hand_icon from "../Assets/hand_icon.png";
import arrow_icon from "../Assets/arrow.png";
import hero_image from "../Assets/hero_image.png";

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-left">
        <h2>NEW ARRIVALS ONLY</h2>
        <div>
          <div className="hero-hand-icon">
            <p>New</p>
            <img src={hand_icon} alt="hello" />
          </div>
          <p>Movies</p>
          <p>For Everyone</p>
        </div>
        <a href="#latest">
          <div className="hero-latest-btn">
            <div>Latest Collection</div>

            <img src={arrow_icon} alt="arrow" />
          </div>
        </a>
      </div>
      <div className="hero-right">
        <img src={hero_image} alt="hero" />
      </div>
    </div>
  );
};

export default Hero;
